import { useMutation } from "@tanstack/react-query"

import { invalidateSessionMedia } from "../invalidateSessionMedia"
import { trpcOptions } from "../trpc"

export function useUpsertVideo(sessionId: string) {
  return useMutation(
    trpcOptions.app.upsertVideo.mutationOptions({ onSuccess: () => invalidateSessionMedia(sessionId) }),
  )
}
